"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const iconoir_react_1 = require("iconoir-react");
// import app components
const button_1 = __importDefault(require("../../elements/button"));
const authTemplate_1 = __importDefault(require("../../combinations/authTemplate"));
const input_1 = __importDefault(require("../../elements/input"));
const Activate = (props) => {
    const { quote, authorOrRole, description, backgroundImage, message, loading, linkComponent, loginLink, passwordResetLink, component, onSubmitSetPassword, } = props;
    const { handleSubmit, control, watch } = (0, react_hook_form_1.useForm)();
    const [showPassword1, setShowPassword1] = (0, react_1.useState)(false);
    const [showPassword2, setShowPassword2] = (0, react_1.useState)(false);
    const handleTogglePassword1 = () => {
        setShowPassword1(!showPassword1);
    };
    const handleTogglePassword2 = () => {
        setShowPassword2(!showPassword2);
    };
    const renderComponent = () => {
        switch (component) {
            case "setPassword":
                return (react_1.default.createElement("form", { key: "setPassword", method: "post", "data-testid": "setPasswordForm", noValidate: true, onSubmit: handleSubmit(onSubmitSetPassword) },
                    react_1.default.createElement(material_1.Stack, { spacing: 4 },
                        react_1.default.createElement(react_hook_form_1.Controller, { name: "password", control: control, defaultValue: "", render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Password", inputProps: { "data-testid": "password1" }, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", error: !!error, helperText: error ? error.message : null, type: showPassword1 ? "text" : "password", endIcon: showPassword1 ? react_1.default.createElement(iconoir_react_1.EyeEmpty, null) : react_1.default.createElement(iconoir_react_1.EyeOff, null), fullWidth: true, disabled: loading, onChange: onChange, onClick: handleTogglePassword1 })), rules: { required: "Password required" } }),
                        react_1.default.createElement(react_hook_form_1.Controller, { name: "confirmPassword", control: control, defaultValue: "", render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Confirm Password ", inputProps: { "data-testid": "password2" }, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", error: !!error, helperText: error ? error.message : null, type: showPassword2 ? "text" : "password", endIcon: showPassword2 ? react_1.default.createElement(iconoir_react_1.EyeEmpty, null) : react_1.default.createElement(iconoir_react_1.EyeOff, null), fullWidth: true, disabled: loading, onChange: onChange, onClick: handleTogglePassword2 })), rules: {
                                required: "Password required",
                                validate: (value) => {
                                    if (watch("password") !== value) {
                                        return "Your passwords do no match";
                                    }
                                },
                            } }),
                        react_1.default.createElement(material_1.Alert, { severity: "info" }, "Password must be minimum 8 characters, include numbers, uppercase and lowercase letters."),
                        react_1.default.createElement(button_1.default, { fullWidth: true, loading: loading, variant: "outlined", type: "submit" }, "Set Password"))));
            case "successfulPasswordSet":
                return react_1.default.createElement(material_1.Alert, { severity: "success" }, "Password set successfully. You can now login with your new credentials.");
            case "activationLinkExpired":
                return (react_1.default.createElement(material_1.Alert, { severity: "error" },
                    "The activation link has expired. Please request a new link via password reset",
                    " ",
                    react_1.default.createElement(material_1.Link, { component: linkComponent, href: passwordResetLink, underline: "hover" }, "here")));
        }
    };
    return (react_1.default.createElement(authTemplate_1.default, { quote: quote, authorOrRole: authorOrRole, description: description, backgroundImage: backgroundImage, message: message, linkComponent: linkComponent, loginLink: loginLink, loginLinkTitle: "Back to Login" }, renderComponent()));
};
exports.default = Activate;
